import Modal from "@/components/base/Modal";
import Button from "@/components/base/Button";
import type { Teacher } from "@/types";

interface DeleteTeacherModalProps {
  teacher: Teacher | null;
  onClose: () => void;
  onConfirm: (teacher: Teacher) => void;
}

export default function DeleteTeacherModal({ teacher, onClose, onConfirm }: DeleteTeacherModalProps) {
  return (
    <Modal
      open={teacher !== null}
      onClose={onClose}
      title="Supprimer l'enseignant"
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button
            variant="danger"
            icon="ri-delete-bin-6-line"
            onClick={() => teacher && onConfirm(teacher)}
          >
            Oui, supprimer
          </Button>
        </>
      }
    >
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-50 text-accent-600">
          <i className="ri-delete-bin-6-line text-lg"></i>
        </span>
        <div>
          <p className="text-sm font-medium text-foreground-900">
            {teacher ? `${teacher.firstName} ${teacher.lastName}` : ""}
          </p>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">
            Voulez-vous vraiment supprimer la fiche de cet enseignant ?
          </p>
          <p className="mt-1 text-xs text-foreground-400">Cette action est irréversible.</p>
        </div>
      </div>
    </Modal>
  );
}